import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon } from "@fortawesome/free-solid-svg-icons/faMoon";
import { faSun } from "@fortawesome/free-solid-svg-icons/faSun";
import { getCurrentTheme, getDefaultTheme, onThemeChanged, themes } from "../../utils/theme";
import { store } from "../../utils/store-instance";
import styles from "./Header.scss";

function currentThemeIsDark() {
  const theme = getCurrentTheme();
  return Boolean(theme?.darkModeDefault || theme?.name?.toLowerCase().includes("dark"));
}

export function ThemeToggle({ compact }) {
  const intl = useIntl();
  const [darkThemeActive, setDarkThemeActive] = useState(currentThemeIsDark);

  useEffect(() => onThemeChanged(() => setDarkThemeActive(currentThemeIsDark())), []);

  const lightTheme = getDefaultTheme();
  const darkTheme = themes.find(theme => theme.darkModeDefault || theme.name?.toLowerCase().includes("dark"));
  const nextThemeName = darkThemeActive ? "light" : "dark";
  const accessibleLabel = intl.formatMessage(
    {
      id: "header.switch-theme",
      defaultMessage: "Switch to {theme} theme"
    },
    { theme: nextThemeName }
  );

  const toggleTheme = () => {
    const nextTheme = darkThemeActive ? lightTheme : darkTheme;
    if (nextTheme) {
      store.update({ preferences: { theme: nextTheme.id } });
    }
  };

  return (
    <button
      type="button"
      className={classNames(styles.themeToggle, compact && styles.themeToggleCompact)}
      aria-label={accessibleLabel}
      aria-pressed={darkThemeActive}
      title={accessibleLabel}
      onClick={toggleTheme}
    >
      <FontAwesomeIcon icon={darkThemeActive ? faMoon : faSun} aria-hidden="true" />
      <span className={styles.themeToggleLabel}>{darkThemeActive ? "Dark" : "Light"}</span>
      <span className={styles.themeToggleTrack} aria-hidden="true">
        <span />
      </span>
    </button>
  );
}

ThemeToggle.propTypes = {
  compact: PropTypes.bool
};
